import styled from 'styled-components';

import ConfigurableModal from '~organisms/ConfigurableModal';

export const Container = styled(ConfigurableModal)({
  height: '100%',
  width: '50% !important',

  '& .ant-modal-content': {
    height: '90%',
    marginTop: '20rem',
  },

  '& .ant-modal-body': {
    height: '80%',
  },

  '& .modal-content': {
    height: '100%',
  },

  '& .ant-modal-footer': {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10rem',
  },
});
